// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
  min-height: 0;
}

.safety-layout {
  display: grid;
  gap: 0.45rem;
  grid-template-rows: auto minmax(0, 1fr);
  height: 100%;
  min-height: 0;
  width: 100%;
}

.section-switcher {
  display: flex;
  gap: 0.3rem;
}

.section-switcher .clean-section-button {
  background: #fff;
  border-color: #aab5c3;
  color: #334b62;
  margin-left: auto;
}

.section-switcher .clean-section-button:hover { border-color: #b4233f; color: #9b1c35; }

.section-switcher button {
  background: #e9eef4;
  border: 1px solid #c9d2dc;
  border-radius: 5px;
  color: #334b62;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 700;
  min-height: 32px;
  min-width: 128px;
  padding: 0.35rem 1rem;
}

.section-switcher .clean-section-button { min-width: 106px; }

.section-switcher button.active {
  background: #1f4e78;
  border-color: #1f4e78;
  color: #fff;
}

.section-content {
  min-height: 0;
  width: 100%;
}

.section-content > app-audit-questionnaire {
  width: 100%;
}

.personnel-card {
  background: #fff;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(19, 42, 70, 0.08);
  height: 100%;
  overflow: hidden;
}

.personnel-card header {
  align-items: center;
  background: #f7f9fc;
  border-bottom: 1px solid #d6e0ea;
  border-left: 4px solid #007bff;
  color: #173a5e;
  display: flex;
  height: auto !important;
  justify-content: space-between;
  margin: 0 !important;
  max-width: none !important;
  min-height: 54px !important;
  padding: 0.35rem 0.65rem;
  width: auto !important;
}

.personnel-card header::before,
.personnel-card header::after {
  content: none !important;
  display: none !important;
}

h2 {
  color: #173a5e;
  font-size: 1rem;
  margin: 0;
}

p {
  color: #66798b;
  font-size: 0.72rem;
  margin: 0.12rem 0 0;
}

.add-person {
  background: #007bff;
  border: 1px solid #007bff;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 112px;
  padding: 0.45rem 0.95rem;
}

.add-person:disabled,
.remove-person:disabled {
  cursor: default;
  opacity: 0.45;
}

.personnel-table {
  padding: 0.8rem;
}

.personnel-head,
.personnel-row {
  align-items: center;
  display: grid;
  gap: 0.55rem;
  grid-template-columns: 32px 1.2fr 1fr 1fr 34px;
}

.personnel-head {
  background: #d9eaf7;
  color: #18364f;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.45rem 0.55rem;
  text-transform: uppercase;
}

.personnel-row {
  border-bottom: 1px solid #e3e7ed;
  min-height: 58px;
  padding: 0.45rem 0.55rem;
}

.personnel-row strong {
  color: #61758a;
  text-align: center;
}

input {
  border: 1px solid #b8c2ce;
  border-radius: 4px;
  font: inherit;
  height: 36px;
  min-width: 0;
  padding: 0.35rem 0.5rem;
  width: 100%;
}

input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);
  outline: none;
}

.remove-person {
  background: transparent;
  border: 0;
  color: #97002e;
  cursor: pointer;
  font-size: 1.3rem;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-audit-checklist/tabs/safety-tab/safety-tab.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA,gDAAgD,qBAAqB,EAAE,cAAc,EAAE;;AAEvF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,0CAA0C,gBAAgB,EAAE;;AAE5D;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n  min-height: 0;\n}\n\n.safety-layout {\n  display: grid;\n  gap: 0.45rem;\n  grid-template-rows: auto minmax(0, 1fr);\n  height: 100%;\n  min-height: 0;\n  width: 100%;\n}\n\n.section-switcher {\n  display: flex;\n  gap: 0.3rem;\n}\n\n.section-switcher .clean-section-button {\n  background: #fff;\n  border-color: #aab5c3;\n  color: #334b62;\n  margin-left: auto;\n}\n\n.section-switcher .clean-section-button:hover { border-color: #b4233f; color: #9b1c35; }\n\n.section-switcher button {\n  background: #e9eef4;\n  border: 1px solid #c9d2dc;\n  border-radius: 5px;\n  color: #334b62;\n  cursor: pointer;\n  font-size: 0.75rem;\n  font-weight: 700;\n  min-height: 32px;\n  min-width: 128px;\n  padding: 0.35rem 1rem;\n}\n\n.section-switcher .clean-section-button { min-width: 106px; }\n\n.section-switcher button.active {\n  background: #1f4e78;\n  border-color: #1f4e78;\n  color: #fff;\n}\n\n.section-content {\n  min-height: 0;\n  width: 100%;\n}\n\n.section-content > app-audit-questionnaire {\n  width: 100%;\n}\n\n.personnel-card {\n  background: #fff;\n  border: 1px solid #d9dee7;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(19, 42, 70, 0.08);\n  height: 100%;\n  overflow: hidden;\n}\n\n.personnel-card header {\n  align-items: center;\n  background: #f7f9fc;\n  border-bottom: 1px solid #d6e0ea;\n  border-left: 4px solid #007bff;\n  color: #173a5e;\n  display: flex;\n  height: auto !important;\n  justify-content: space-between;\n  margin: 0 !important;\n  max-width: none !important;\n  min-height: 54px !important;\n  padding: 0.35rem 0.65rem;\n  width: auto !important;\n}\n\n.personnel-card header::before,\n.personnel-card header::after {\n  content: none !important;\n  display: none !important;\n}\n\nh2 {\n  color: #173a5e;\n  font-size: 1rem;\n  margin: 0;\n}\n\np {\n  color: #66798b;\n  font-size: 0.72rem;\n  margin: 0.12rem 0 0;\n}\n\n.add-person {\n  background: #007bff;\n  border: 1px solid #007bff;\n  border-radius: 4px;\n  color: #fff;\n  cursor: pointer;\n  font-size: 0.75rem;\n  font-weight: 700;\n  min-width: 112px;\n  padding: 0.45rem 0.95rem;\n}\n\n.add-person:disabled,\n.remove-person:disabled {\n  cursor: default;\n  opacity: 0.45;\n}\n\n.personnel-table {\n  padding: 0.8rem;\n}\n\n.personnel-head,\n.personnel-row {\n  align-items: center;\n  display: grid;\n  gap: 0.55rem;\n  grid-template-columns: 32px 1.2fr 1fr 1fr 34px;\n}\n\n.personnel-head {\n  background: #d9eaf7;\n  color: #18364f;\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 0.45rem 0.55rem;\n  text-transform: uppercase;\n}\n\n.personnel-row {\n  border-bottom: 1px solid #e3e7ed;\n  min-height: 58px;\n  padding: 0.45rem 0.55rem;\n}\n\n.personnel-row strong {\n  color: #61758a;\n  text-align: center;\n}\n\ninput {\n  border: 1px solid #b8c2ce;\n  border-radius: 4px;\n  font: inherit;\n  height: 36px;\n  min-width: 0;\n  padding: 0.35rem 0.5rem;\n  width: 100%;\n}\n\ninput:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.15);\n  outline: none;\n}\n\n.remove-person {\n  background: transparent;\n  border: 0;\n  color: #97002e;\n  cursor: pointer;\n  font-size: 1.3rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
